function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.28,
  dy: 0.28
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 0.85
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#1d1d1b",
  floodOpacity: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2d6188",
  className: "cls-1",
  d: "M30.52,24.96c-5.94,0-10.76-4.82-10.76-10.76S24.57,3.43,30.52,3.43s10.76,4.82,10.76,10.76-4.82,10.76-10.76,10.76"
});

function SvgRegler03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44.22 27.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    fill: "#2d6188",
    style: {
      opacity: 0.5
    },
    className: "cls-2",
    d: "M32.24,21.19c4.1,0,7.43-3.13,7.43-7h0c0-3.87-3.33-7-7.43-7H11.98c-4.1,0-7.43,3.13-7.43,7h0c0,3.87,3.33,7,7.43,7"
  }), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegler03);
export default __webpack_public_path__ + "static/media/regler-03.2590a3df50198f10ccaa6f4df4a35ff7.svg";
export { ForwardRef as ReactComponent };